import { FC, useEffect, useState } from 'react';
import { IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import './ImageViewer.scss';
import HoleDetectionImage from './Image/HoleDetectionImage';

type PropsType = {
  image: string;
};

const ImageViewer: FC<PropsType> = ({ image }): JSX.Element => {
  const [isOpen, setIsOpen] = useState(false);
  const [currentImage, setCurrentImage] = useState('');

  const openImage = (src) => {
    setCurrentImage(src);
    setIsOpen(true);
  };

  const closeImage = () => {
    setIsOpen(false);
    setCurrentImage('');
  };

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        closeImage();
      }
    };

    if (isOpen) {
      window.addEventListener('keydown', handleKeyDown);
    }

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [isOpen]);

  return (
    <div className="gallery">
      <HoleDetectionImage src={image} openImage={openImage} />

      {isOpen && (
        <div className="gallery__overlay">
          <img
            src={currentImage}
            alt="Full size"
            className="gallery__full-image"
          />
          <IconButton
            color="secondary"
            onClick={closeImage}
            className="gallery__close-button"
          >
            <CloseIcon sx={{ color: 'white' }} />
          </IconButton>
        </div>
      )}
    </div>
  );
};

export default ImageViewer;
